<template>
  <RegionPage />
</template>

<script setup lang="ts">
import RegionPage from '@/pages/regions/[rid]/index.vue'

definePageMeta({
  middleware: ['check-region'],
})
</script>
